/* MoveVeilComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./MoveVeilRenderer");

class MoveVeilComponent extends EventEmitter {
    constructor(logger, gameEditor, devices) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._devices = devices;
        // Fix for the async await
        this._ = _;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }
    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._context = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "MoveVeilComponent.shutdown() error");
            }
        );
    }
    /* jshint ignore:start */

    async getPlan() {
        let currentPlanID = this._gameEditor.getPlan().id;
        let plans = await this._gameEditor._planEntity.loadOsUpgradePlans(this._gameEditor._activeOrgId);
        let plansToDropDown = [];
        plans.map((plan) => {
            let planSchedule;
            plan.loadPlanSchedule().then((result) => (planSchedule = result));
            if (plan.id !== currentPlanID && (plan.status === "DRAFT" || plan.status === "INVALID") && planSchedule === undefined) {
                plansToDropDown.push({ label: plan.name, value: plan.id });
            }
        });

        let plansSorted = _.sortBy(plansToDropDown, [
            function (o) {
                return o.label;
            }
        ]);

        this.renderer._existingPlan.setOptions(plansSorted);
    }

    moveToPlan(moveType, planNameOrID) {
        this._context.resolve({ type: moveType, id: planNameOrID });
    }
    /* jshint ignore:end */

    // async _createPlan(name) {
    //     this._osPlan.name = name;
    //     this._osPlan.description = "";
    //     return await this._osPlan.create();
    // }

    cancelMove(err) {
        this._context.reject(err);
    }
    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = MoveVeilComponent;
